import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { StubsService } from '../Services/stubs.service';
import { Service } from '../models/service.model';
import { SharedData } from '../shared-data/shared-object.service';
import { AuthenticationService } from '../Services/authentication.service';
import { Http, Headers, RequestOptions } from '@angular/http';
@Component({
  selector: 'app-services-overview',
  templateUrl: './services-overview.component.html',
  styleUrls: ['./services-overview.component.css']
})
export class ServicesOverviewComponent implements OnInit, OnDestroy {

  private services: Service[]=[];

  public currentIndex;

  public enableServiceEdit: Boolean;

  public showAutomationDataForServices = {};

  public showOverview = false;
  public categories: any = null;
  public checkbox : any =[];
  public filteredCats: Service;
  public clonedServices: Service[] = [];
  public loadTable = false;
  public selectedOptionsForCategory: Service[] = [];

  constructor(private _stubsService: StubsService, private _route: ActivatedRoute, private http: Http,
    private _router: Router, public _sharedData: SharedData, public authService: AuthenticationService) { }

  public initalizeServicesAndCategories() {

    return this._stubsService.getServicesData()
      .map(() => {
        this.services = this._sharedData.sharedServices;
        this.clonedServices = this._sharedData.sharedServices;
        this.setCategories();
        this.mapCategoriesAndSet();
      }, error => console.log(error));
  }
  ngOnInit(): void {

    this.authService.getUser().subscribe(() => {

      this.enableServiceEdit = this.authService.currentUserRole == 'developer' || !this.authService.currentUserRole;
    });

    this.initalizeServicesAndCategories().subscribe(() => {
      this.showOverview = true;
    });
  }

  setCategories() {
      this._stubsService.getCategories().subscribe((res) => {
        this.categories = res.json();
        this.mapCategoriesAndSet();
      });
  }

  mapCategoriesAndSet() {
    const categoryNames = {};

    if (Array.isArray(this.categories)) {

      this.categories.forEach(category => {

        categoryNames[category._id] = category.value;
      });

      this.services = this.services.map((service: any, index) => {
        if (Array.isArray(service.category)) {

          this.services[index].categoryNames = service.category.map((categoryId) => categoryNames[categoryId]);
        }

        return service;
      });
    }

    setTimeout(() => {
      this.loadTable = true;
    })
  }
  viewStubs(id: string): void {

    this._router.navigate(['/stubsoverview', id]);
  }

  deleteService(serviceId) {
    this._stubsService.deleteService(serviceId)
      .subscribe(res => {
        this.services = this.services.filter(item => item._id !== serviceId)
      },
        error => console.log(error));
  }

  public tryItOut(index: number) {
    this.currentIndex = index;
  }

  public showAutomationData(service) {

    this.showAutomationDataForServices[service._id] = true;
  }

  public hideAutomationData(service) {

    delete this.showAutomationDataForServices[service._id];
  }

  public checkedCategory(category) {

    const categoryIndex = this.selectedOptionsForCategory.indexOf(category._id);
    this.services = this.clonedServices;
    if (categoryIndex >= 0) {

      this.selectedOptionsForCategory.splice(categoryIndex, 1);
    } else {

      this.selectedOptionsForCategory.push(category._id);
    }

    if (this.selectedOptionsForCategory && this.selectedOptionsForCategory.length > 0) {

      this.services = this.services.filter((item) => {

        const matches = item.category && item.category.filter((catgoryForService) => item.category &&
          this.selectedOptionsForCategory.indexOf(catgoryForService) >= 0);

        return matches && !!matches.length;
      });
    }
  }

  ngOnDestroy() {

    this.services.forEach((service: any, index) => {

      delete this.services[index].categoryNames;
    });
  }
}


// WEBPACK FOOTER //
// ./src/app/services-overview/services-overview.component.ts